module.exports = __webpack_public_path__ + "media/images/user/logo-bea3ac116435aab42d498eaa7e1a43fd.svg";